import { render, staticRenderFns } from "./EditClientModal.vue?vue&type=template&id=597977ed&scoped=true&class=fill-height&"
import script from "./EditClientModal.vue?vue&type=script&lang=ts&"
export * from "./EditClientModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditClientModal.vue?vue&type=style&index=0&id=597977ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597977ed",
  null
  
)

export default component.exports